import { currentSession } from '../actions/actions'
import { clearAmplifyStore } from '../actions/amplifyUser.store'
import { startAmplifyOnce } from './startAmplifyOnce'

export const getJwtToken = async (): Promise<string> => {
    try {
        startAmplifyOnce()
        const session = await currentSession()
        const jwtToken = session.getAccessToken().getJwtToken()
        return jwtToken
    } catch (e) {
        console.error('getJwtToken error. Logged out?', e)
        clearAmplifyStore()
        // await signOut()
        // throw e
        return ''
    }
}
